import type { BlockType } from "../core/editor-state";

export interface BlockDefinition {
  type: BlockType;
  title: string;
  icon?: string;
  defaultContent: string;
}

const registry = new Map<BlockType, BlockDefinition>();

export function registerBlock(def: BlockDefinition) {
  registry.set(def.type, def);
}

export function getBlock(type: BlockType): BlockDefinition | undefined {
  return registry.get(type);
}

export function getAllBlocks(): BlockDefinition[] {
  return Array.from(registry.values());
}
